import { AnyIfEmpty } from 'react-redux';

import axios, { AxiosResponse } from 'axios';
import { vendorAppointmentAccessCodeProps } from '../../../components/vendorAppointments/VendorAppointments';
import {
    GET_KEY_PICKUP_DROP_VISIT_FAILURE,
    GET_KEY_PICKUP_DROP_VISIT_REQUEST,
    GET_KEY_PICKUP_DROP_VISIT_SUCCESS,
} from '../constants/keyPickupDropEventVisit.constants';
import { keyPickupDropAccessCodeProps } from '../../../components/keyPickupDropEvents/KeyPickupDrop';

const getKeyPickupDropVisitRequest = () => {
    return {
        type: GET_KEY_PICKUP_DROP_VISIT_REQUEST,
    };
};

const getKeyPickupDropVisitSuccess = (locationByIdData: AnyIfEmpty<object>) => {
    return {
        type: GET_KEY_PICKUP_DROP_VISIT_SUCCESS,
        payload: locationByIdData,
    };
};

const getKeyPickupDropVisitFailure = (locationByIdError: string) => {
    return {
        type: GET_KEY_PICKUP_DROP_VISIT_FAILURE,
        payload: locationByIdError,
    };
};

export const getKeyPickupDropVisit = (locationId: string | any) => {
    return async (dispatch: AnyIfEmpty<object>) => {
        dispatch(getKeyPickupDropVisitRequest());
        return await axios
            .get(`/property-events-visit/${locationId}`)
            .then((response: AxiosResponse) => {
                if (response.data.statusCode === 200) {
                    dispatch(getKeyPickupDropVisitSuccess(response?.data?.data));
                } else {
                    dispatch(getKeyPickupDropVisitFailure(response.data.message));
                }
            })
            .catch((err) => dispatch(getKeyPickupDropVisitFailure(err?.response?.data?.message)));
    };
};

export const getKeyPickupDropLocationVisit = (
    keyPickupDropEvents: keyPickupDropAccessCodeProps,
    onSuccess: (accessCode: string) => void,
    onBMSSuccess: (message: string) => void,
    onFailure: (message: string) => void,
    setLoading: (loading: boolean) => void,
) => {
    return async () => {
        setLoading(true);
        axios
            .get(`/property-events-visit`, {
                params: {
                    latitude: keyPickupDropEvents.latitude,
                    longitude: keyPickupDropEvents.longitude,
                    eventId: keyPickupDropEvents.eventId,
                },
            })
            .then(async (response) => {
                if (response?.data?.statusCode === 200) {
                    if (response?.data?.code) {
                        onSuccess(response?.data?.code);
                    }
                    if (response?.data?.locker) {
                        onBMSSuccess(response?.data?.message);
                    }
                } else {
                    onFailure(response?.data?.message);
                }
            })
            .catch((error) => {
                onFailure(error?.response?.data?.message);
            })
            .finally(() => {
                setLoading(false); // Stop loader
            });
    };
};
